



































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { Getter, Mutation } from 'vuex-class';

import { mapGetters } from 'vuex';
import { Photo } from '../../../models/photo';

@Component
export default class PhotoSelection extends Vue {

    @Getter('configuration/photosLiked') private photosLiked: Photo[];
    @Getter('configuration/photosDisliked') private photosDisliked: Photo[];

    @Mutation('configuration/removeLike') private removeLike;
    @Mutation('configuration/removeDislike') private removeDislike;
}
